import { render, staticRenderFns } from "./SetSnapshotDialog.vue?vue&type=template&id=154358de"
import script from "./SetSnapshotDialog.vue?vue&type=script&lang=js"
export * from "./SetSnapshotDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports